import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApplikasiKreditService from "services/Setup/LoanOrigination/Loan/ApplikasiKreditService";
import ApprovalKreditService from "services/Setup/LoanOrigination/ProsesKredit/ApprovalKredit/ApprovalKreditService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  loadingPosGeneral: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  approvalKreditList: [], 
  statusRespon: 0,
};

export const getApkLoanRequestForCreditApproval = createAsyncThunk(
  "ApprovalKredit/getApkLoanRequestForCreditApproval",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApprovalKreditService.getApkLoanRequestForCreditApproval(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
 
 


export const ApprovalKreditSlice = createSlice({
  name: "ApprovalKredit",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = 0;
    },
    setcreditStepKTA: (state, action) => {
      state.creditStepKTA = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      //getApkLoanRequestForCreditApproval
      .addCase(getApkLoanRequestForCreditApproval.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApkLoanRequestForCreditApproval.fulfilled, (state, action) => {  
        console.log("🚀 ~ file: ApprovalKreditSlice.js ~ line 106 ~ .addCase ~ action", action);
        
        state.loading = false;
        state.approvalKreditList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getApkLoanRequestForCreditApproval.rejected, (state, action) => {
        state.loading = false;
      }) 
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setcreditStepKTA,
} = ApprovalKreditSlice.actions;

export default ApprovalKreditSlice.reducer;
